<template>
  <div id="pageRoot">
    <img src="/pages/img/sordovio/assets_p1/nube1.svg" style="position: absolute; width: 500px; top: 30px; left: 20px; z-index: 1" class="slideItem" />
    <img src="/pages/img/sordovio/assets_p1/titulo.svg" style="position: absolute; width: 400px; top: 150px; left: 70px; z-index: 2" class="appearAnimationA" />
    <img src="/pages/img/sordovio/assets_p1/nube2.svg" style="position: absolute; width: 500px; top: 90px; left: 450px; z-index: 2"  class="slideItemB"/>
    <img src="/pages/img/sordovio/assets_p1/sol.svg" style="position: absolute; width: 200px; top: 40px; left: 470px; z-index: 1" />
    <img src="/pages/img/sordovio/assets_p1/nube0.svg" style="position: absolute; width: 300px; top: 40px; left: 510px; z-index: 0; animation-duration: 6s"  class="slideItem"/>
    <img src="/pages/img/sordovio/assets_p1/arboles.svg" style="position: absolute; width: 380px; top: 280px; left: 600px; z-index: 3" />
    <img src="/pages/img/sordovio/assets_p1/piso.svg" style="position: absolute; width: 900px; top: 530px; left: 115px; z-index: 4" />
    <img src="/pages/img/sordovio/assets_p1/rocas.svg" style="position: absolute; width: 500px; top: 510px; left: 15px; z-index: 4" />
     <img src="/pages/img/sordovio/assets_p1/guitarrero.svg" style="position: absolute; width: 200px; top: 450px; left: 190px; z-index: 5" class="bouncingItem" />

  </div>
</template>
<style scoped>
#bg{
    position: absolute;
    left: 18px;
    top: 36px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["vio/Video 1b.mp4"]
    }
  }
}
</script>